/* eslint-disable react/forbid-dom-props */ function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import * as PropTypes from 'prop-types';
import { TooltipHost } from '@fluentui/react';
import { v4 } from 'uuid';
import { getUserFavouriteEntityServiceType } from '@shared/utils/userFavouriteDedicatedUtils';
import SpzaComponent from '@shared/components/spzaComponent';
import { BaseTile } from '@shared/containers/baseTile';
import { Constants } from '@shared/utils/constants';
import { generateTileClickPayloadAndLogTelemetry, getProductsList } from '@shared/utils/detailUtils';
import { getComponentXYCoordinate } from '@shared/utils/reactUtils';
import { routes } from '@shared/routerHistory';
import { findBestMatchCountryCode, getReplacedCountryQueryParam, createCountryFilterQueryParam, getProductTitleForTile, getStartingPriceHeader } from '@shared/utils/consultingServicesUtils';
import { stripHTML } from '@shared/utils/appUtils';
import IntegratedSolution from '@shared/images/badges/IntegratedSolution.svg';
import AzureExpertsMSPBadge from '@shared/images/badges/AzureExpertsMSP.svg';
export class ServiceTile extends SpzaComponent {
    getService(e) {
        var _this_props_extraData;
        e.stopPropagation();
        const { tileIndex, totalTiles, setTileCheckoutSource } = this.props;
        const reference = this.refs['appTile' + this.props.entityId];
        const coordinate = getComponentXYCoordinate(reference);
        const { ribbonKey = '' } = this.props;
        setTileCheckoutSource();
        const details = {
            id: this.props.entityId,
            rank: {
                rank: tileIndex + 1,
                total: totalTiles
            },
            xOffset: coordinate.x,
            yOffset: coordinate.y,
            CTAType: ((_this_props_extraData = this.props.extraData) === null || _this_props_extraData === void 0 ? void 0 : _this_props_extraData.serviceActionType) || '',
            currentView: this.props.currentView
        };
        generateTileClickPayloadAndLogTelemetry(Constants.Telemetry.ActionModifier.ServiceTileCTAButton, details);
        this.context.ctaCallback({
            entity: this.props,
            entityType: Constants.EntityType.Service,
            ctaType: Constants.CTAType.Service,
            actionModifier: Constants.Telemetry.ActionModifier.ServiceTileCTAButton,
            ribbonKey
        });
    }
    shouldComponentUpdate(nextProps) {
        return this.props.entityId !== nextProps.entityId || this.props.currentView !== nextProps.currentView || this.props.countryContext !== nextProps.countryContext;
    }
    renderPrice() {
        const { extraData, countryContext, selectedLocale } = this.props;
        return getStartingPriceHeader(extraData === null || extraData === void 0 ? void 0 : extraData.multiCountryPricing, countryContext, selectedLocale, this.context);
    }
    renderBuiltForItem() {
        return /*#__PURE__*/ _jsx("div", {
            children: getProductTitleForTile(this.props.products)
        });
    }
    getReplacedCountryQueryParamIfNeeded() {
        // Play defense - return alternative country only if we can find one.
        if (this.props.extraData && this.props.extraData.multiCountryPricing && this.props.extraData.multiCountryPricing[0]) {
            // No country context - use first country as default.
            if (!this.props.countryContext) {
                const firstCountry = this.props.extraData.multiCountryPricing[0].countryRegion;
                let replaceCountryParam = getReplacedCountryQueryParam(this.props.query, firstCountry);
                // No country query param to replace - create new one.
                if (!replaceCountryParam) {
                    replaceCountryParam = createCountryFilterQueryParam(firstCountry, this.props.isAppSource);
                }
                return replaceCountryParam;
            }
            const foundCountryCode = findBestMatchCountryCode(this.props.extraData.multiCountryPricing, this.props.countryContext);
            // If there is mismatch between country context and what we found in the service. replace the country param.
            if (foundCountryCode !== this.props.countryContext && this.props.query) {
                return getReplacedCountryQueryParam(this.props.query, foundCountryCode);
            }
        }
        return null;
    }
    renderBadge() {
        var _this_props_tags;
        const AzureExpertsMSP = ((_this_props_tags = this.props.tags) === null || _this_props_tags === void 0 ? void 0 : _this_props_tags.length) > 0 && this.props.tags.indexOf(Constants.BadgeType.AzureExpertsMSP) >= 0;
        const hasIntSolutionBadge = Object.prototype.hasOwnProperty.call(Constants.ServicesIdWithBadge, this.props.entityId);
        const tooltipText = this.context.loc('MicrosoftIntegratedSolution_badge', 'Microsoft Integrated Solution badge');
        if (!hasIntSolutionBadge && !AzureExpertsMSP) {
            return null;
        }
        return /*#__PURE__*/ _jsxs("div", {
            className: 'tileBadgeContainer',
            children: [
                hasIntSolutionBadge && /*#__PURE__*/ _jsx("div", {
                    className: "serviceTileBadge",
                    tabIndex: 0,
                    children: /*#__PURE__*/ _jsx(TooltipHost, {
                        content: tooltipText,
                        children: /*#__PURE__*/ _jsx("img", {
                            src: IntegratedSolution,
                            alt: tooltipText
                        })
                    })
                }),
                AzureExpertsMSP && /*#__PURE__*/ _jsx("div", {
                    className: "expertBadge",
                    children: /*#__PURE__*/ _jsx("img", {
                        className: "tileBadge",
                        src: AzureExpertsMSPBadge,
                        title: this.context.loc('AzureExpertsMSP_Badge', 'Azure Experts MSP'),
                        alt: this.context.loc('AzureExpertsMSP_Badge', 'Azure Experts MSP')
                    })
                })
            ]
        });
    }
    getCTAData() {
        var _this_props_extraData;
        const ctaText = ((_this_props_extraData = this.props.extraData) === null || _this_props_extraData === void 0 ? void 0 : _this_props_extraData.serviceActionType) || '';
        return ctaText && {
            id: Constants.JsllCTAId.ContactMe,
            title: this.context.loc('CTA_Services'),
            area: 'Services Tile',
            onClick: this.getService.bind(this),
            entityId: this.props.entityId
        };
    }
    getProducts() {
        var _this_props;
        return ((_this_props = this.props) === null || _this_props === void 0 ? void 0 : _this_props.products) && Object.keys(this.props.products).length > 0 && getProductsList(this.props.products);
    }
    renderImpl() {
        var _this_props_extraData;
        const { ribbonKey = '', countryContext } = this.props;
        const replaceCountryParams = this.getReplacedCountryQueryParamIfNeeded() || countryContext && {
            country: countryContext
        };
        const serviceDetailUrl = this.context.buildHref(routes.serviceDetail, {
            entityId: this.props.entityId
        }, replaceCountryParams, true);
        var _this_props_extraData_shortDescription;
        return /*#__PURE__*/ _jsx(BaseTile, {
            totalTiles: this.props.totalTiles,
            id: this.props.entityId,
            componentInstance: this.componentInstance,
            item: this.props.item,
            iconURL: this.props.extraData && this.props.extraData.smallIconUri,
            title: this.props.title,
            description: stripHTML((_this_props_extraData_shortDescription = (_this_props_extraData = this.props.extraData) === null || _this_props_extraData === void 0 ? void 0 : _this_props_extraData.shortDescription) !== null && _this_props_extraData_shortDescription !== void 0 ? _this_props_extraData_shortDescription : ''),
            publisher: this.props.publisher,
            ctaData: this.getCTAData(),
            detailUrl: serviceDetailUrl,
            tileIndex: this.props.tileIndex,
            currentView: this.props.currentView,
            userFavouriteEntityType: getUserFavouriteEntityServiceType(),
            price: this.renderPrice(),
            badge: this.renderBadge(),
            openTileCallback: this.context.openTileCallback,
            products: this.getProducts(),
            context: this.context,
            ribbonKey: ribbonKey
        });
    }
    constructor(props, context){
        super(props, context), _define_property(this, "context", void 0), _define_property(this, "componentInstance", v4());
        this.getReplacedCountryQueryParamIfNeeded = this.getReplacedCountryQueryParamIfNeeded.bind(this);
    }
}
ServiceTile.contextTypes = {
    loc: PropTypes.func,
    locParams: PropTypes.func,
    buildHref: PropTypes.func,
    ctaCallback: PropTypes.func,
    renderErrorModal: PropTypes.func,
    openTileCallback: PropTypes.func
};
